import {Component, inject} from '@angular/core';
import {FormControl, Validators, AbstractControl, ValidationErrors} from '@angular/forms';
import {EretailModalComponent} from '../../../../shared/components/modal/eretail-modal/eretail-modal.component';
import {EretailContentWrapperHeaderComponent} from '../../../../shared/components/eretail-content-wrapper/eretail-content-wrapper-header/eretail-content-wrapper-header.component';
import {EretailFieldComponent} from '../../../../shared/components/eretail-field/eretail-field.component';
import {ButtonComponent} from '../../../../shared/components/button/eretail-button/button.component';
import {UserService} from 'src/app/core/services/user.service';
import {ToastService} from 'src/app/core/helpers/toast.service';
import {FormErrorComponent} from 'src/app/shared/components/form-error/form-error.component';

@Component({
  selector: 'app-edit-my-password-dialog',
  standalone: true,
  imports: [
    EretailModalComponent,
    EretailContentWrapperHeaderComponent,
    ButtonComponent,
    EretailFieldComponent,
    FormErrorComponent,
  ],
  templateUrl: './edit-my-password-dialog.component.html',
  styleUrl: './edit-my-password-dialog.component.scss',
})
export class EditMyPasswordDialogComponent {
  private _user = inject(UserService);
  private _toast = inject(ToastService);

  currentPassword = new FormControl('', Validators.required);
  newPassword = new FormControl('', [this.strongPasswordValidator]);
  confirmPassword = new FormControl('', Validators.required);

  ngOnInit() {}

  onSubmit() {
    if (this.newPassword.invalid) {
      this._toast.showErrorToast('Senha nova inválida', 'A senha não atende os critérios de segurança.');
      return;
    }

    const newPasswordRequest: any = {
      senhaAtual: this.currentPassword.value?.trim(),
      novaSenha: this.newPassword.value?.trim(),
      confirmaNovaSenha: this.confirmPassword.value?.trim(),
    };

    this._user.changePassword(newPasswordRequest).subscribe(
      (res) => {
        this._toast.showSuccessToast('Senha alterada com sucesso', '');
      },
      (e) => {
        this._toast.showErrorToast(
          'Não foi possível alterar a senha',
          'Confirme a validação das informações ou contate o suporte.'
        );
      }
    );
  }

  private strongPasswordValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value || '';
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumber = /\d/.test(value);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);

    const isValid = hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar;

    return !isValid
      ? {
          strongPassword:
            'A senha deve conter pelo menos uma letra maiúscula, uma letra minúscula, um número e um caractere especial.',
        }
      : null;
  }
}
